export const debounce = <T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number,
  immediate: boolean,
) => {
  let timeout: ReturnType<typeof setTimeout> | null = null
  return function (this: unknown, ...args: Parameters<T>): Promise<ReturnType<T>> {
    return new Promise<ReturnType<T>>((resolve) => {
      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(() => {
        timeout = null
        if (!immediate) {
          Promise.resolve(func.apply(this, [...args])).then((value) =>
            resolve(value as ReturnType<T>),
          )
        }
      }, wait)
      if (immediate && !timeout) {
        Promise.resolve(func.apply(this, [...args])).then((value) =>
          resolve(value as ReturnType<T>),
        )
      }
    })
  }
}
